import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from 'src/components/layout/layout';
import { useAppSelector } from 'src/reducers';
import styles from './homepage.module.scss';

const Homepage = () => {
  const navigate = useNavigate();

  const { isAuthenticated } = useAppSelector(state => state.authentication);

  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/login');
    }
  }, [isAuthenticated, navigate]);

  return (
    <div className="container">
        <div className={styles.dashboardContainer}>
          <div className={styles.title}>ADAMANTIC</div>
          <div className={styles.subtitle}>Enterprise Resource Planning</div>
        </div>
    </div>
  );
};

export default Homepage;
